import React, { Fragment } from 'react';

import { HeadingLevel, Text, TypographyName } from '@zapier/design-system';

import { SizeType } from '../../../types';

type SectionProps = {
  /** Title to display. */
  title: string;
  /** Optional title typography, which will override the default style */
  titleTypography?: TypographyName;
  /** Optional children to render one heading level lower. */
  children?: React.ReactNode;
  /** Size to display. */
  size?: SizeType;
};

/**
 * Renders a title, with optional children under the next heading level.
 */
const Section = ({
  children,
  title,
  titleTypography,
  size = 'large',
}: SectionProps) => {
  return (
    <Fragment>
      <Text
        type={
          titleTypography ?? size === 'small' ? 'SectionHeader' : 'PageHeader'
        }
      >
        {title}
      </Text>
      {children && (
        <HeadingLevel>
          <Text>{children}</Text>
        </HeadingLevel>
      )}
    </Fragment>
  );
};

export default Section;
